'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var themeShape = _propTypes2.default.shape({
  vstui: _propTypes2.default.shape({
    direction: _propTypes2.default.oneOf(['ltr', 'rtl']),
    palette: _propTypes2.default.shape({
      common: _propTypes2.default.shape({
        black: _propTypes2.default.string,
        white: _propTypes2.default.string,
        transparent: _propTypes2.default.string
      }),
      primary: _propTypes2.default.shape({
        getShade: _propTypes2.default.func,
        getMainShade: _propTypes2.default.func,
        name: _propTypes2.default.string
      }),
      secondary: _propTypes2.default.shape({
        getShade: _propTypes2.default.func,
        getMainShade: _propTypes2.default.func,
        name: _propTypes2.default.string
      }),
      error: _propTypes2.default.shape({
        getShade: _propTypes2.default.func,
        getMainShade: _propTypes2.default.func,
        name: _propTypes2.default.string
      }),
      success: _propTypes2.default.shape({
        getShade: _propTypes2.default.func,
        getMainShade: _propTypes2.default.func,
        name: _propTypes2.default.string
      })
    }),
    typography: _propTypes2.default.shape({
      fontFamily: _propTypes2.default.string,
      fontSize: _propTypes2.default.number,
      fontWeightLight: _propTypes2.default.number,
      fontWeightRegular: _propTypes2.default.number,
      fontWeightMedium: _propTypes2.default.number,
      fontWeightBold: _propTypes2.default.number,
      fontWeightBlack: _propTypes2.default.number,
      htmlFontSize: _propTypes2.default.number,
      pxToRem: _propTypes2.default.func
    }),
    transitions: _propTypes2.default.shape({
      easing: _propTypes2.default.shape({
        easeIn: _propTypes2.default.string,
        easeOut: _propTypes2.default.string
      }),
      duration: _propTypes2.default.shape({
        shortest: _propTypes2.default.string,
        short: _propTypes2.default.string,
        enteringScreen: _propTypes2.default.string,
        leavingScreen: _propTypes2.default.string
      })
    }),
    sizes: _propTypes2.default.shape({
      small: _propTypes2.default.number,
      medium: _propTypes2.default.number,
      large: _propTypes2.default.number
    })
  })
});

exports.default = themeShape;